import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
  class: "custom-component"
};
var _hoisted_2 = {
  class: "exercise-box"
};
var _hoisted_3 = {
  class: "exercise-box-top"
};
var _hoisted_4 = {
  class: "exercise-title"
};
var _hoisted_5 = {
  class: "exercise-box-note"
};
var _hoisted_6 = {
  key: 0,
  class: "exercise-box-bottom"
};
var _hoisted_7 = {
  key: 0,
  class: "sum"
};
var _hoisted_8 = {
  key: 1,
  class: "sum"
};
var _hoisted_9 = {
  key: 1,
  class: "exercise-content"
};
var _hoisted_10 = {
  class: "exercise-item"
};
var _hoisted_11 = {
  class: "exercise-type"
};
var _hoisted_12 = {
  key: 0
};
import commonTxt from './commonTxt.vue';
import ExerciseQuestion from './question.vue';

/* 工具 */
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { getStore } from '@/util/store';
export default {
  __name: 'eExercise',
  props: {
    elementContent: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    element: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    edit: {
      type: Boolean,
      default: true
    }
  },
  emits: ['loaded'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    /* 组件 */
    var props = __props;
    var emit = __emit;
    var EXERCISE_CODE_MAP = {
      SINGLE_CHOICE: '单选题',
      MULTIPLE_CHOICE: '多选题',
      JUDGE: '判断题',
      COMPLETION: '填空题',
      ANSWER_QUESTIONS: '简答题',
      COMPREHENSIVE: '综合题'
    };
    var route = useRoute();
    var _route$query = route.query,
      courseId = _route$query.courseId,
      groupId = _route$query.groupId,
      type = _route$query.type;
    var exercise = JSON.parse(props.elementContent.exercise.content);
    /* const exerciseList = exercise.paperNavs.flatMap((item) => {
      return item.paperNavItems
    }) */
    var noteHtml = computed(function () {
      return props.elementContent.exercise.note || '';
    });
    var note = ref(noteHtml.value);
    var exerciseList = exercise.paperNavs.reduce(function (result, item) {
      return result.concat(item.paperNavItems);
    }, []);
    var token = getStore({
      name: 'access_token'
    });
    var userInfo = getStore({
      name: 'userInfo'
    });
    var isSimple = computed(function () {
      return props.elementContent.exercise.style === 'simple';
    });
    var getExerciseType = function getExerciseType(type) {
      return EXERCISE_CODE_MAP[type];
    };
    var paperId = computed(function () {
      var info = exercise.paperResponcesInfo;
      if (info && info.paperId) {
        return info.paperId;
      }
      return '';
    });
    onMounted(function () {
      emit('loaded', 'eExercise');
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_svg_icon, {
        name: "course-exercise"
      }), _createTextVNode("习练 " + _toDisplayString(_unref(exercise).title), 1)]), _cache[0] || (_cache[0] = _createElementVNode("template", null, [_createElementVNode("div", {
        class: "preview"
      }, "习练预览")], -1))]), _createElementVNode("div", _hoisted_5, [_createVNode(commonTxt, {
        "initial-content": note.value
      }, null, 8, ["initial-content"])]), isSimple.value ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("template", null, [_cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "progress"
      }, [_createTextVNode("进度 "), _createElementVNode("strong", null, "x"), _createTextVNode("/y")], -1)), _unref(groupId) && _ctx.published ? (_openBlock(), _createElementBlock("div", _hoisted_7, "批阅统计")) : _createCommentVNode("", true), _unref(groupId) && !_ctx.published ? (_openBlock(), _createElementBlock("div", _hoisted_8, "未发布")) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(exerciseList), function (item) {
        var _item$exercisesData;
        return _openBlock(), _createElementBlock("div", {
          key: item.exercisesId
        }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString(getExerciseType(item.exercisesData.type)), 1), _createVNode(ExerciseQuestion, {
          "exercises-data": item.exercisesData
        }, null, 8, ["exercises-data"]), item.exercisesData.type === 'COMPREHENSIVE' && (_item$exercisesData = item.exercisesData) !== null && _item$exercisesData !== void 0 && _item$exercisesData.childs && item.exercisesData.childs.length ? (_openBlock(), _createElementBlock("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.exercisesData.childs, function (child, index) {
          return _openBlock(), _createElementBlock("div", {
            key: index,
            class: "comprehensive"
          }, [_createElementVNode("span", null, "（" + _toDisplayString(index + 1) + "）", 1), _createVNode(ExerciseQuestion, {
            index: index + 1,
            "exercises-data": child
          }, null, 8, ["index", "exercises-data"])]);
        }), 128))])) : _createCommentVNode("", true)])]);
      }), 128))]))])]);
    };
  }
};